// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"d4-z","dimensionLabel":"e4-z","styleChooserControlWrapper":"f4-z","styleChooserControl":"g4-z","disabled":"h4-z","giftCard":"i4-z","styleChooserText":"j4-z"};